

import { ClosestWithClass } from "../../../components/Utilities/HTMLHelpers";
import { LeftCaret, RightCaret } from "../../../components/Icons/Carets";
import XIcon from "../../../components/Icons/XIcon";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { CSSProperties } from "styled-components";


//width:"calc(100% - 64px)"
const lightboxImageStyle:CSSProperties = {height:"calc(90% - 64px)",objectFit:"contain",maxWidth:"95%",userSelect:"none"};

export default function ProductLightBox({portal,url,onClose,allImages,onPickImage}:{portal:HTMLElement,url:string,onClose:()=>void,allImages:string[],onPickImage:(url:string)=>void}){

    return createPortal(
        <div className=" lightbox-close center-all no-delay vanimation-fade-in block-edit"
        id="lighbox-bg"
        onMouseDown={(e)=>{
    

            if((e.target as HTMLElement).classList.contains("lightbox-close"))
                onClose();
            
        }}
        style={{position:"fixed",left:0,top:0,width:"100%",height:"100%",background:"#ffffffee",zIndex:3000,paddingBottom:"5%"}}>
             <button onClick={onClose}  className="invisible-button font-large" style={{color:"#333",position:"absolute",top:"8px",right:"8px",background:"none"}}><XIcon/></button>
    
        <ProductImageSlider  allImages={allImages} url={url} onPickImage={onPickImage} imgStyle={lightboxImageStyle} includeArrows={true} includeDots={true}/>
        </div>,portal);
    
}



const wrapping = [0,1,2,3,4]; // used for rendering images relatively to the selected index

export function ProductImageSlider({allImages,url,onPickImage,imgStyle,includeArrows,includeDots,overrideZoom}:{overrideZoom?:Function, allImages:string[],url:string,onPickImage:(url:string)=>void,imgStyle:CSSProperties,includeArrows:boolean,includeDots:boolean}){

    const [zoomState,setZoomState] = useState(1);

    const zoomRef = React.useRef(1);
    const toggleZoom = ()=>{
        setZoomState((zoomRef.current==1?2:1));
        zoomRef.current = (zoomRef.current==1?2:1);
        initialZoomRef.current = zoomRef.current;
    }

    useEffect(()=>{

        if(zoomState == 1){
            scrollOffsetX.current = 0;
            scrollOffsetY.current = 0;
        }
    },[zoomState])

    const updateSelectedImage = (url:string)=>{
        selectedImageRef.current = url;
        setSelectedImage(url);
        onPickImage(url);
    }

    const selectedIndexRef = React.useRef(allImages.indexOf(url));


    //due to asynchronous updates we need to store most information in refs
    const [selectedImage, setSelectedImage] = useState(url);
    const selectedImageRef = React.useRef(url);

    const [isDragging,setIsDragging] = useState(false);
    const isDragginRef = React.useRef(false);
    const downTime = useRef(Date.now())
    const [dragX, setDragX] = useState(0);
    const dragYRef = React.useRef(0);
    const dragXRef = React.useRef(0);
    
    const scrollOffsetX = useRef(0);
    const scrollOffsetY = useRef(0);


    const mouseDownRefX = React.useRef(0);
    const mouseDownRefY = React.useRef(0);

    function emulateMouseMoveFromTouch(e: TouchEvent) {
        let pushEvent = new MouseEvent("mousemove", {
          clientX: e.touches[0].clientX,
          clientY: e.touches[0].clientY,
        });
            handleDragMove(pushEvent);
      
      }
    

     function handleTouchMove(e: TouchEvent) {

        if(isTouchScalingRef.current && startDistance.current>0){
            let dist = GetDistance(e);
            let diff = dist-startDistance.current;
            let zoom =   initialZoomRef.current + diff/100.0;
            if(zoom<1){
                zoom = 1;
            }
            else if(zoom>5){
                zoom = 5;
            }
            zoomRef.current = zoom;
            setZoomState(zoom);
        }

        else if(ClosestWithClass(e.target as HTMLElement,"lightbox-close")){
            emulateMouseMoveFromTouch(e);
            e.preventDefault();
            e.stopPropagation();
        }
 
      }


    const handleDragStart=(e:PointerEvent)=>{

        let t = e.target as HTMLElement;
        downTime.current = e.timeStamp;

        if(t.tagName!="IMG"){

            isDragginRef.current = false;
            setIsDragging(false);
            return;
        }

        mouseDownRefX.current = e.clientX ;
        mouseDownRefY.current = e.clientY;
        
      
        isDragginRef.current = true;
        setIsDragging(true);
    
    }  

    const handleDragMove=(e:any)=>{

        if(isTouchScalingRef.current){
            // mouseDownRefX.current = e.clientX; // reset each time if scaling
            // mouseDownRefY.current = e.clientY;
            return;
        }

        else if(isDragginRef.current){
   
            let x = (e.clientX - mouseDownRefX.current)/zoomRef.current;
            setDragX(x);
            dragXRef.current = x;
            dragYRef.current = (e.clientY - mouseDownRefY.current);
        }



    }

    const GetWrappedIndex = (index:number)=>{
                if(index<0){

                    let prevIndex = index;
                    let abs = index*-1;
                    let dif = abs%allImages.length;
                    index = (allImages.length-dif)%allImages.length;
            
                }
                else{
                    index = index%allImages.length;
                }

                return index;
    }

    function Slide(direction:number){
        selectedIndexRef.current += direction;
        updateSelectedImage(allImages[GetWrappedIndex(selectedIndexRef.current)]);
    }


    function GoToImage(url:string){

        let current = allImages.indexOf(selectedImageRef.current);
        let targetIndex = allImages.indexOf(url);
        let diff = targetIndex-current;
        Slide(diff);
        

    }

    const isTouchScalingRef = useRef(false);
    const [isTouchScaling,setIsTouchScaling] = useState(false);
    const startDistance = useRef(0);
    const initialZoomRef = useRef(1);

    function GetDistance(e:TouchEvent){
        if(e.touches.length<2){
            return 0;
        }
        return Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY);

    }

    function HandleTouchStart(e:TouchEvent){
        if(e.touches.length==2&&!overrideZoom){
            let dist = GetDistance(e);
            if(dist<10)
                return;
            
            isTouchScalingRef.current = true;
            setIsTouchScaling(true);

            initialZoomRef.current = zoomRef.current;
            startDistance.current = GetDistance(e);
        }
    }



    function HandleTouchEnd(e:TouchEvent){
        if(isTouchScalingRef.current){
            setIsTouchScaling(false);
            isTouchScalingRef.current = false;
            if(zoomRef.current < 1.2){ // snap back to avoid zoom behavior when visually not zoomed
                setZoomState(1);
                zoomRef.current = 1;
            }
            startDistance.current = 0;
        }
    }


    function handleDragEnd(e:PointerEvent){


        if(!isDragginRef.current){
            return;
        }
     
        const minAmount = Math.min(200,window.innerWidth/8);

        let abs = Math.abs(dragXRef.current);
    

        if(abs>minAmount && zoomRef.current<1.05){

            if(dragXRef.current<0){
                Slide(1);
  
            }else{
                Slide(-1);
   
            }
      
        }
        else if( abs<20 ){
            let dif = e.timeStamp - downTime.current;
        

            if(dif< 500){

                if(overrideZoom){
                    overrideZoom();
                }
                else if(!isTouchScalingRef.current)
                    toggleZoom();
            }
        }

  
        if(zoomRef.current>1){
            scrollOffsetX.current += dragXRef.current; ;
            scrollOffsetY.current += dragYRef.current;
        }



        setDragX(0);
        dragXRef.current = 0;
        dragYRef.current = 0;
        
        setIsDragging(false);
        isDragginRef.current = false;
    }

    const preventDrag = (e:DragEvent)=>{
        e.preventDefault();
        e.stopPropagation();
    }

    useEffect(()=>{

        document.addEventListener("pointerdown",handleDragStart,{passive:true});
        document.addEventListener("pointermove",handleDragMove,{passive:true});
        document.addEventListener("pointerup",handleDragEnd,{passive:true});
        document.addEventListener("touchmove", handleTouchMove, { passive: false });
        document.addEventListener("touchstart",HandleTouchStart,{passive:true});
        document.addEventListener("touchend",HandleTouchEnd,{passive:true});
        document.addEventListener("touchcancel",HandleTouchEnd,{passive:true});
        document.addEventListener("dragstart",preventDrag);



        return ()=>{
            document.removeEventListener("pointermove",handleDragMove);
            document.removeEventListener("pointerup",handleDragEnd);
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("pointerdown",handleDragStart);
            document.removeEventListener("dragstart",preventDrag);
            document.removeEventListener("touchstart",HandleTouchStart);
            document.removeEventListener("touchend",HandleTouchEnd);
            document.removeEventListener("touchcancel",HandleTouchEnd);
        }
    },[])

    return <> <div className="image-row h-full w-full lightbox-close" style={{touchAction:"none"}}  >
        {includeArrows&&zoomState<1.1&&
        <>
        <div className="center-all h-full hide-mobile lightbox-close" style={{fontSize:"36px",position:"fixed",left:"7%",zIndex:10}}><button onClick={()=>Slide(-1)} style={{background:"none",color:"#33333355",padding:"10vh 2vw"}} className="invisible-button"><LeftCaret/></button></div>
        <div className="center-all h-full hide-mobile lightbox-close" style={{fontSize:"36px",position:"fixed",right:"7%",zIndex:10}}><button onClick={()=>Slide(1)} style={{background:"none",color:"#33333355",padding:"10vh 2vw",transform:"scalex(-1)"}} className="invisible-button"  ><LeftCaret/></button></div>
        </>
        }
        {wrapping.map((i)=>{

            let index = selectedIndexRef.current+i-2;
            let imgIndex = GetWrappedIndex(index);
            return <RenderImageAtPos  imgStyle={imgStyle} zoom={zoomState} key={index} img={allImages[imgIndex]} index={index} dragX={dragX + scrollOffsetX.current} dragY={dragYRef.current+scrollOffsetY.current} selectedIndex={selectedIndexRef.current} stopTransition={(isDragging||isTouchScaling)}/>

        })

     }

</div>

        <div className="bottom-row flex-row gap-med scrollable max-100" style={{position:"absolute",padding:"8px",bottom:"24px"}}>

        {includeDots&&<>
        { allImages.map((img,index)=>{
           return <button className="invisible-button" 
           style={{width:"10px",height:"10px",background:selectedImage===img?"#333":"#aaa",borderRadius:"50px",border:(selectedImage===img?"1px solid #999":"none"),padding:"0"}}
            onClick={(e)=>{e.stopPropagation(); GoToImage(img);} }
            key={index} >
            </button>
        })}
        </>
    }

        
        </div></>

}



function RenderImageAtPos({zoom, img,index,dragX,dragY,selectedIndex,stopTransition,imgStyle}:{imgStyle:CSSProperties,zoom:number, stopTransition:boolean,selectedIndex:number, img:string,index:number,dragX:number,dragY:number}){
    if(zoom > 1 && index != selectedIndex){
        return null; // don't render other images when in zoom state
    }

    let calcZoom = (index == selectedIndex?zoom:1);
    // let pos = window.innerWidth*(index-selectedIndex) + dragX;
    let perc = (index-selectedIndex) * 100;
    let pos = `calc(${perc}% + ${dragX}px)`;

 

    return <div className="center-all relative lightbox-close" style={{zIndex:(index==selectedIndex?5:0),
    cursor:(zoom>1?"grab":"zoom-in"),
    width:"100%",height:"100%",position:"absolute",transition:(stopTransition?"none":"transform .3s"),transform:`scale(${calcZoom}) translatex(${pos} ) ` +(calcZoom>1? `translatey(${dragY/calcZoom}px)`:" translatey(0)")}}>  
        <img 
        alt = {"image "+index}
        key={index} src={img} style={{...imgStyle}}/>
    </div>
}